import { render } from "./statistics.vue?vue&type=template&id=18c8fe54&scoped=true&ts=true"
import script from "./statistics.vue?vue&type=script&lang=ts"
export * from "./statistics.vue?vue&type=script&lang=ts"

import "./statistics.vue?vue&type=style&index=0&id=18c8fe54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c8fe54"]])

export default __exports__